import { FaroTable } from "@components/common/faro-table/faro-table";
import { getCreditPurchasesColumns } from "@components/table/transactions/credit-purchases-columns";
import { CreditPurchasesHistoryHeaders } from "@components/table/transactions/transactions-table-utils";
import { Alert } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
import { useTokenPurchase } from "@hooks/use-token-purchase";
import { Box } from "@mui/material";
import { allCreditSubscriptionsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { TableType } from "@utils/track-event/track-event-list";
import { useMemo } from "react";

/** List of required columns in the credits purchases history table */
const requiredColumns = [
  CreditPurchasesHistoryHeaders.package,
  CreditPurchasesHistoryHeaders.purchasedDate,
  CreditPurchasesHistoryHeaders.expirationDate,
  CreditPurchasesHistoryHeaders.status,
  CreditPurchasesHistoryHeaders.creditsRemaining,
];

/** Renders the table for credits history */
export function CreditPurchasesTable(): JSX.Element {
  const { shouldShowNewIndication } = useTokenPurchase();
  const { formatDate } = useDateTime();
  const subscriptions = useAppSelector(allCreditSubscriptionsSelector);
  const tableColumns = useMemo(
    () =>
      requiredColumns.map(
        (requiredColumn) =>
          getCreditPurchasesColumns({ formatDate })[requiredColumn]
      ),
    [formatDate]
  );

  return (
    <>
      {shouldShowNewIndication && (
        <Alert
          variant="info"
          title="The most recent tokens you purchased will be available here shortly."
          sx={{ marginY: "24px" }}
        />
      )}
      <Box
        sx={{
          overflow: "hidden",
        }}
      >
        <FaroTable
          entities={subscriptions}
          uniqueIdKey="uiTemporaryId"
          isLoading={false}
          shouldHideCheckbox={true}
          columns={tableColumns}
          rowHeight={70}
          tableType={TableType.creditPurchases}
        />
      </Box>
    </>
  );
}
